<template>
  <div class="spread">
    <div class="entry">
      <div class="big-title">
        <p>线上售楼处</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>专为企业打造官方营销入口，购房客户线上体验全面升级</h2>
        </div>
        <p>
          以移动设备作为展示平台，在手机、平板电脑等移动端进行展示的房产销售产品,扩大了营销渠道，疏通行业信息传播渠道，加强用户体验。
        </p>
      </div>
      <div class="second-title">特点</div>
      <div class="trait">
        <div
          class="item"
          v-for="item in traitList"
          :key="item.id"
          @mouseenter="onmouseEntry(item.id, 'trait')"
          @mouseleave="onmouseLeave('trait')"
        >
          <img v-if="traitId == item.id" :src="item.activeImg" />
          <img v-else :src="item.img" />

          <div class="right">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
      </div>
      <div class="second-title">优势</div>
      <div class="advantage">
        <div
          class="item"
          v-for="item in advantageObj.descList"
          :key="item.id"
          @mouseenter="onmouseEntry(item.id, 'advantage')"
          @mouseleave="onmouseLeave('advantage')"
        >
          <img v-if="advantageId == item.id" :src="advantageObj.activeImg" />
          <img v-else :src="advantageObj.img" />
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
      <div class="second-title">功能</div>
      <div class="feature">
        <div
          class="item"
          v-for="item in featureList"
          :key="item.id"
          @mouseleave="onmouseLeave('feature')"
          @mouseenter="onmouseEntry(item.id, 'feature')"
        >
          <img v-if="featureId == item.id" :src="item.img" />
          <img v-else :src="item.activeImg" />
          <div class="ct">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
      <div class="second-title">样机显示效果</div>
    </div>

    <div class="effect">
      <div class="phone-box">
        <div class="row-tab">
          <div class="swiper-container myRow" ref="slider">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                :class="{ active: selectId == item.id }"
                v-for="(item, index) in featureList"
                :key="item.id"
                @click="changeRowTabs(item.id, index)"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>

        <div class="column-tab">
          <div class="swiper-container myColumn" ref="columnSwiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in featureList"
                :key="item.id"
              >
                <img :src="item.img" />
                <span>{{ item.title }}</span>
                <div class="desc">
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tool">
      <div class="big-title">
        <p>拓客工具包</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>专为置业顾问打造的全能工具台，销售拓客工具All in One</h2>
        </div>
      </div>
      <div class="content">
        <div class="item">
          <div class="title">发名片</div>
          <div class="line"></div>
          <div class="desc">
            <p>身份认证，留下好印象</p>
            <img src="../../static/images/product/card.png" />
          </div>
        </div>
        <div class="item">
          <div class="title">访客管理</div>
          <div class="line"></div>
          <div class="desc">
            <p>客户来源追溯，标签化管理</p>
            <img src="../../static/images/product/fangke.png" />
          </div>
        </div>
        <div class="item">
          <div class="title">线下拓客</div>
          <div class="line"></div>
          <div class="desc">
            <p>扫码收客，数据闭环</p>
            <img src="../../static/images/product/xianxia.png" />
          </div>
        </div>
        <div class="item">
          <div class="title">VR带看</div>
          <div class="line"></div>
          <div class="desc">
            <p>1V1互动讲解，身临其境</p>
            <img src="../../static/images/product/vr.png" />
          </div>
        </div>
        <div class="item">
          <div class="title">直播看房</div>
          <div class="line"></div>
          <div class="desc">
            <p>随时随地，开团看房</p>
            <img src="../../static/images/product/live.png" />
          </div>
        </div>
        <div class="item">
          <div class="title">电子笔记</div>
          <div class="line"></div>
          <div class="desc">
            <p>支持生成海报分享</p>
            <img src="../../static/images/product/book.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="analysis">
      <div class="big-title">
        <p>数据分析平台</p>
        <div class="line"></div>
      </div>
      <div class="small-title">
        <div class="frist-line">
          <img src="../../static/images/product/whole_icon.png" />
          <h2>专为管理者打造的智能数据分析平台为管理提效赋能</h2>
        </div>
        <div class="second-title">功能</div>
        <div class="features">
          <img src="../../static/images/product/fea.png" />
          <div class="desc">
            <h2>客户描摹</h2>
            <p>数据洞察，关键指标拆解。</p>
          </div>
        </div>
      </div>
    </div>
    <address class="five-footer">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a @click="jumpService">立即咨询</a>
    </address>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  data() {
    return {
      traitId: -1,
      advantageId: -1,
      featureId: -1,
      rowSwiper: "",
      columnSwiper: "",
      selectId: 0,
      advantageObj: {
        img: require("../../static/images/product/duigou.png"),
        activeImg: require("../../static/images/product/duigou_white.png"),
        descList: [
          { id: 0, desc: "完整还原地产产品减少成本、减少时间；" },
          {
            id: 1,
            desc: "弥补纸质展示的不足提高后期回访和转化",
          },
          {
            id: 2,
            desc: "线上看房留联提升转为成单用户机率",
          },
        ],
      },
      traitList: [
        {
          id: 0,
          img: require("../../static/images/product/loupan.png"),
          activeImg: require("../../static/images/product/loupan_active.png"),
          title: "楼盘信息整合",
          desc:
            "看房零距离&价值全面传达。交通、配套、政策等全面价值分层展示清晰展示项目价值。",
        },
        {
          id: 1,
          img: require("../../static/images/product/jingxi.png"),
          activeImg: require("../../static/images/product/jingxi_active.png"),
          title: "精细动态交互",
          desc:
            "项目调性塑造&平面视觉展现。精细动态区位地图，更鲜活生动地展示项目内容。",
        },
        {
          id: 2,
          img: require("../../static/images/product/pingtai.png"),
          activeImg: require("../../static/images/product/pingtai_active.png"),
          title: "平台直连客户",
          desc:
            "楼盘分享传播&一键预约看房。通过微信分享传播，助推项目广泛识别度和品牌知名度。",
        },
        {
          id: 3,
          img: require("../../static/images/product/shuzi.png"),
          activeImg: require("../../static/images/product/shuzi_active.png"),
          title: "数字化购房体验",
          desc: "以数字化手段提升客户购房体验、提升销售全周期服务里程碑。",
        },
      ],
      featureList: [
        {
          id: 0,
          img: require("../../static/images/product/dushu.png"),
          activeImg: require("../../static/images/product/dushu_active.png"),
          title: "微楼书",
          desc: "展示楼盘单价、信息、特色、周边配套等详情",
        },
        {
          id: 1,
          img: require("../../static/images/product/zaixian.png"),
          activeImg: require("../../static/images/product/zaixian_active.png"),
          title: "在线咨询",
          desc: "IM即时聊天，告别电话销售的尴尬",
        },
        {
          id: 2,
          img: require("../../static/images/product/youhui.png"),
          activeImg: require("../../static/images/product/youhui_active.png"),
          title: "优惠活动",
          desc: "拉新引流，一站式全民营销",
        },
        {
          id: 3,
          img: require("../../static/images/product/kehu.png"),
          activeImg: require("../../static/images/product/kehu_active.png"),
          title: "推荐客户",
          desc: "展示楼盘单价、信息、特色、周边配套等详情",
        },
        {
          id: 4,
          img: require("../../static/images/product/jifen.png"),
          activeImg: require("../../static/images/product/jifen_active.png"),
          title: "积分商城",
          desc: "社区运营，提高用户粘性",
        },
        {
          id: 5,
          img: require("../../static/images/product/goufang.png"),
          activeImg: require("../../static/images/product/goufang_active.png"),
          title: "线上购房",
          desc: "专业保障，促进成单",
        },
      ],
    };
  },
  mounted() {
    let that = this;
    that.rowSwiper = new Swiper(".myRow", {
      slidesPerView: 3.5,
      freeMode: false,
      loop: false,
    });
    that.columnSwiper = new Swiper(".myColumn", {
      direction: "vertical",
      slidesPerView: "auto",
      on: {
        slideChange() {
          that.selectId = this.activeIndex;
          that.rowSwiper.slideTo(this.activeIndex, 300, false);
        },
      },
    });
  },
  methods: {
    jumpService() {
      this.$addConsult()
    },
    onmouseEntry(id, type) {
      switch (type) {
        case "trait":
          this.traitId = id;
          break;
        case "advantage":
          this.advantageId = id;
          break;
        case "feature":
          this.featureId = id;
          break;
      }
    },
    changeRowTabs(id, index) {
      this.selectId = id;
      this.columnSwiper.slideTo(index, 300, false);
    },

    onmouseLeave(type) {
      switch (type) {
        case "trait":
          this.traitId = -1;
          break;
        case "advantage":
          this.advantageId = -1;
          break;
        case "feature":
          this.featureId = -1;
          break;
      }
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import '../../../node_modules/swiper/dist/css/swiper.css';

.effect {
  display: flex;
  justify-content: center;
  height: 668px;
  background: url('../../static/images/product/effect_bg.png') no-repeat;

  .phone-box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url('../../static/images/product/phone_box.png') no-repeat;
    width: 286px;
    height: 641px;
  }

  .row-tab {
    margin: -60px 20px 0 28px;
    width: 239px;
    cursor: pointer;

    .swiper-slide {
      font-size: 12px;
      font-weight: 500;
      color: #999999;
      text-align: center;
    }

    .swiper-slide.active {
      position: relative;
      color: #333333;
    }

    .swiper-slide.active::after {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
      content: '';
      width: 21px;
      height: 1px;
      background: #333333;
    }
  }

  .column-tab {
    margin-top: 50px;
    margin-left: 64px;
    width: 229px;
    max-height: 438px;
    border-radius: 0px 0px 20px 20px;

    .swiper-container {
      width: 229px;
      max-height: 388px;
    }

    .swiper-slide {
      margin-bottom: 98px;
      width: 220px;

      span {
        text-align: center;
        font-size: 18px;
        font-weight: 800;
        color: #333333;
        padding-left: 10px;
      }

      .desc {
        width: 167px;
        font-size: 16px;
        font-weight: 500;
        color: #666666;
        line-height: 32px;
        margin-top: 24px;
      }
    }
  }
}

.spread {
  width: 100%;
  padding: 139px 0 0;
  background-color: #fff;

  .big-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 76px;

    p {
      font-size: 30px;
      font-weight: bold;
      color: #333333;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .small-title {
    .frist-line {
      display: flex;
      align-items: center;
    }

    h2 {
      font-weight: bold;
      margin: 0 0 0 12px;
      font-size: 22px;
      font-weight: bold;
      color: #333333;
    }

    p {
      font-size: 18px;
      font-weight: 500;
      color: #666666;
      line-height: 28px;
      padding: 17px 0 0 40px;
    }
  }

  .second-title {
    font-size: 22px;
    font-weight: 800;
    color: #333333;
    margin: 80px 0 54px;
  }

  .entry {
    padding: 0px 360px 120px;

    .trait {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      .item {
        display: flex;
        width: 415px;
        height: 135px;
        max-width: 50%;
        box-sizing: border-box;

        img {
          max-width: 42px;
          max-height: 42px;
        }
      }

      .item:hover .right .item-title::after {
        transform: scaleX(1);
        transform-origin: left;
      }

      .right {
        margin-left: 28px;

        .item-title {
          position: relative;
          font-size: 18px;
          font-weight: 800;
          color: #333333;
          margin-bottom: 26px;
        }

        .item-title::after {
          content: '';
          top: 30px;
          left: 0px;
          position: absolute;
          width: 138px;
          height: 1px;
          background: #FFC000;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 1.5s;
        }

        .item-desc {
          font-size: 16px;
          font-weight: 500;
          color: #666666;
          line-height: 24px;
        }
      }
    }

    .advantage {
      display: flex;
      justify-content: center;
      align-items: center;

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 401px;
        height: 164px;
        background: #FFFFFF;
        border: 1px solid #E1E6F0;
        box-sizing: border-box;

        .desc {
          margin-left: 11px;
          font-size: 16px;
          font-weight: 800;
          color: #333333;
        }
      }

      .item:hover {
        background: #EDB50B;
      }
    }

    .feature {
      display: flex;
      align-items: center;

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        flex-direction: column;
        text-align: center;
        width: 201px;
        height: 292px;
        padding: 30px 0 92px;

        .ct {
          margin-top: 44px;

          .title {
            font-size: 18px;
            font-weight: 800;
            color: #333333;
          }

          .desc {
            padding: 20px 35px 0;
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            line-height: 24px;
          }
        }
      }

      .item:hover {
        border: 1px solid #C0C0C0;
      }

      .item:hover .title {
        color: #EDB50B;
      }
    }
  }

  .tool {
    padding: 68px 360px 72px;
    background: #F5F5F5;

    .content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 80px;
      width: 100%;

      .item:hover .line {
        background: #FFC000;
      }

      .item {
        box-sizing: border-box;
        padding: 51px 34px 0 31px;
        width: 32.8%;
        height: 181px;
        background: #FFFFFF;
        margin-bottom: 8px;

        .title {
          font-size: 18px;
          font-weight: 800;
          color: #333333;
        }

        .line {
          width: 32px;
          height: 3px;
          background: #ADB0B8;
          margin-top: 8px;
        }

        .desc {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 22px;

          p {
            font-size: 16px;
            font-weight: 500;
            color: #666666;
          }
        }
      }
    }
  }

  .analysis {
    padding: 68px 360px 120px;

    .features {
      display: flex;

      .desc {
        margin: 88px 0 0 76px;
      }

      h2 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        margin-left: 0;
      }

      p {
        padding-left: 0;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 28px;
      }
    }
  }

  .five-footer {
    width: 100%;
    height: 160px;
    background: url('../../static/images/fiveG/bg(1).png');
    text-align: center;
    border-sizing: border-box;
    position: relative;
    z-index: 3;

    h3 {
      padding-top: 20px;
      font-size: 24px;
      line-height: 50px;
      color: #FFFDF9;
    }

    a {
      text-decoration: none;
      display: inline-block;
      width: 200px;
      height: 44px;
      margin: 16px auto;
      font-size: 18px;
      font-weight:bold;
      color: #FFFEFC;
      line-height: 44px;
      border: 1px solid #FFFEFC;
      border-radius: 5px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/MarketSpread.vue